import React from 'react'
import { NavLink } from 'react-router-dom'

const menus = [
    {
        name:'Brands A-Z',
        target:'/'
    },
    {
        name:"Men's",
        target:"/category/men"
    },
    {
        name:'Women',
        target:"/category/women"
    },
    {
        name:"Servives",
        target:'/services'
    }
]
const SubHeader = () => {
    return(
        <div className="border-b-1 border-t-1 border-gray-400">
            <div className="px-16 container mx-auto py-10 overflow-auto">
                <ul className="flex items-center justify-between lg:justify-center">
                    {menus.map((item,i) =>{ 
                        return(
                            <li key={i}>
                                <NavLink exact to={item.target} activeClassName="font-bold active" className="font-light text-sm block px-16 lg:px-32 flex whitespace-nowrap hover:text-gray-400">{item.name}</NavLink>
                            </li>
                        )
                    })}
                    
                </ul>
            </div>
        </div>
    )
}
export default SubHeader;